const forms = document.getElementsByClassName('form__wrapper')

if (forms.length)
    window.$(function () {
        window.$('.form__wrapper form').on({
            submit: function () {
                var $self = window.$(this)
                window.$('.alert.alert-success').remove()
                window.$('.alert.alert-error').remove()
                window.$('button[type=submit]', $self).prop('disabled', true)

                window.$.ajax({
                    type: 'post',
                    dataType: 'json',
                    data: window.$(this).serialize(),
                    success: function (response) {
                        window.$('ul.errors.help-block', $self).remove()
                        window.$('.has-error', $self).removeClass('has-error')

                        if (response.success && response.finished) {
                            $self[0].reset()

                            // Special message for hall of honor submissions
                            var $message = ''

                            if (response.returnUrl && (response.returnUrl.indexOf('/alumni/alumni-recognition/athletics-hall-of-honor') >= 0)) {
                                window.$('.form__thank-you').addClass('is--active')
                                window.$('.form__wrapper form, .rich-text__wrapper.rich-text.111').hide()
                                var thanksMessageTop = window.$('.form__thank-you').offset().top
                                window.$('html, body')
                                    .animate({ scrollTop: thanksMessageTop - 75 }, 300)
                            }
                            else {
                                $message = window.$('<div>', {
                                    class: 'alert alert-success'
                                }).append('<p>Form submitted successfully!</p>', {
                                    class: 'lead'
                                })

                                window.$('.form__wrapper form').append($message)
                            }
                        }
                        else if (response.errors) {
                            var $failMessage = window.$('<div>', {
                                class: 'alert alert-error'
                            }).append('<p>Please fix errors above</p>', {
                                class: 'lead'
                            })

                            $self.after($failMessage)

                            for (var key in response.errors) {
                                if (!response.errors[`${key}`])
                                    continue

                                var messages = response.errors[key]
                                var $errors = window.$('<ul>', { class: 'errors help-block' })
                                for (var i = 0; i < messages.length; i++) {
                                    var $li = window.$('<li>')
                                    $li.html(messages[i])
                                    $errors.append($li)
                                }

                                var $input = window.$('*[name='
                                    + key + "], *[name='"
                                    + key + "[]']")

                                const $formGroup = $input.parents('.freeform-column')
                                $formGroup.addClass('has-error')

                                $formGroup.append($errors)
                            }
                        }

                        window.$('button[type=submit]', $self).prop('disabled', false)
                    }
                })

                return false
            }
        })
    })
